/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ankit Rajput",
  title: "Hi all, I'm Ankit",
  subTitle: emoji(
    //"A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
    `
    I am a master’s student in computer science at Arizona State University 🚀 with six years of industry experience, 
    including roles at PayPal, Paytm, and GE. Skilled in full-stack development, I excel in building scalable web projects 
    and modernizing legacy systems to microservices. With strong communication, leadership, and problem-solving skills, 
    I focus on delivering high-performance solutions for commercial lending platforms.
    `
  ),
  resumeLink: "https://drive.google.com/file/d/1GOVtNodAzfAcNhLfRbilOOOdBc55LRYf/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ankitrajput0096",
  linkedin: "https://www.linkedin.com/in/ankitrajput022/",
  leetcode: "https://leetcode.com/u/ankitrajput12/",
  gmail: "arajpu15@asu.edu",
  instagram: "https://www.instagram.com/ankitrajput3837/",
  facebook: "https://www.facebook.com/ankitrajput022",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Proficient Full Stack Developer with a strong foundation in Machine Learning and Deep Learning.",
  skills: [

    emoji(
      "⚡ Design and develop highly scalable backend architectures for web and mobile applications, capable of handling global user traffic efficiently."
    ),

    emoji(
      "⚡ Extensive experience in developing interactive and visually appealing web applications utilizing React, Redux, Node.js, and D3.js libraries."
    ),

    emoji(
      "⚡ Comprehensive understanding of Machine Learning and Deep Learning principles, with hands-on experience in creating personalized chatbots using Large Language Models (LLMs)."
    ),
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Arizona State University (ASU)",
      logo: require("./assets/images/ASU_Logo.jpg"),
      subHeader: "Master of Science in Computer Science",
      duration: "August 2024 - May 2026",
      desc: "CGPA: 4.00/4.00",
      desc2: "Relevant Courses:",
      descBullets: [
        "Data Visualization",
        "Knowledge Representation & Reasoning",
        "Software Validation & Verification"
      ]
    },
    {
      schoolName: "Rashtreeya Vidyalaya College of Engineering (RVCE)",
      logo: require("./assets/images/RVCE_Logo.png"),
      subHeader: "Bachelor of Engineering in Computer Science",
      duration: "August 2014 - July 2018",
      desc: "CGPA: 9.09/10.00",
      desc2: "Relevant Courses:",
      descBullets: [
        "Data Structures & Algorithms",
        "Object Oriented Analysis & Design",
        "Java & JEE",
        "Database Management"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer 3",
      company: "PayPal",
      companylogo: require("./assets/images/paypal_logo_6.png"),
      date: "April 2021 – July 2024",
      desc: `As a Software Engineer 3 at PayPal's Global Merchant Lending team, I played a pivotal role in enhancing compliance, 
      expanding market presence, and leveraging advanced technologies to improve product efficiency and revenue growth.`,
      descBullets: [
        "Led compliance initiatives, including Fair Credit Reporting Act adherence and KYB feature implementation, processing 100K requests/month across EMEA.",
        "Contributed to the migration of risk evaluation to advanced machine learning models for real-time loan application assessments.",
        "Directed the expansion of PayPal Working Capital into the Netherlands and France, resulting in a 15% increase in annual revenue."
      ]
    },
    {
      role: "Software Engineer",
      company: "Paytm",
      companylogo: require("./assets/images/paytm_logo.webp"),
      date: "April 2020 – April 2021",
      desc: `As a Software Engineer at Paytm, I contributed to the Loan Management System by improving financial accessibility, 
      managing critical modules, and ensuring seamless functionality for millions of users.`,
      descBullets: [
        "Enhanced the User Loan EMI Product on the Paytm app by developing the Loan Account Management module, enabling real-time user account creation.",
        "Took full ownership of designing and implementing the Due Past Days (DPD) calculation module, accurately tracking overdue EMI days for over 1 million active users daily.",
        "Demonstrated strong problem-solving and ownership skills in developing critical loan management features to support Paytm's financial ecosystem."
      ]
     },
    {
      role: "Software Engineering Specialist",
      company: "General Electric (GE)",
      companylogo: require("./assets/images/ge_logo_2.jpg"),
      date: "July 2018 – April 2020",
      desc: `As a Software Engineering Specialist at General Electric, I contributed to developing innovative tools that 
      improved service planning and automated ticket resolution, enhancing efficiency and productivity in power plant operations.`,
      descBullets: [
        "Developed a Spring-based calculation engine for the Plant Solution Configurator (PSC) to process real-time turbine sensor data (up to 100 GB) and propose enhanced power plant service plans.",
        "Designed an AI-powered ticket resolution system using text and image classification models, automating turbine cleaning ticket management and reducing manual workload by 40 hours per week.",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects 🎯",
  subtitle: "Here are some of my GitHub projects that leverage cutting-edge technologies widely utilized in the software industry.",
  github_profile_link: "https://github.com/ankitrajput0096",
  projects: [
    {
      image: require("./assets/images/LLM_project_2.jpg"),
      projectName: "",
      projectDesc: "QueryPal integrates Llama 2.0, ChromaDB, and LangChain to enable seamless document retrieval and accurate, user-friendly query handling.",
      footerLink: [
        {
          name: "Visit Project",
          url: "https://github.com/ankitrajput0096/QueryPal-Personalized-AI-Friend"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/kafka_project.png"),
      projectName: "",
      projectDesc: "This project deploys a Dockerized Apache Kafka cluster with Zookeeper for high availability and integrates Spring Boot-based producer-consumer apps for seamless message processing.",
      footerLink: [
        {
          name: "Visit Project",
          url: "https://github.com/ankitrajput0096/Kafka_ZooKeeper_SpringBoot_Producers_Consumers"
        }
      ]
    },
    {
      image: require("./assets/images/Redis_project.png"),
      projectName: "",
      projectDesc: "This project deploys a Dockerized Spring Boot app with a Redis sentinel cluster and PostgreSQL, offering scalable, fault-tolerant caching and data storage.",
      footerLink: [
        {
          name: "Visit Project",
          url: "https://github.com/ankitrajput0096/SpringBoot_Caching_With_RedisCache_Sentinel"
        }
      ]
    },
    {
      image: require("./assets/images/Spring_project.png"),
      projectName: "",
      projectDesc: "This project showcases a Dockerized Spring Boot app with PostgreSQL, using JPA and Hibernate for data persistence, orchestrated via Docker Compose for easy deployment.",
      footerLink: [
        {
          name: "Visit Project",
          url: "https://github.com/ankitrajput0096/Dockerized_SpringBoot_PostgreSQL"
        }
      ]
    },
    {
      image: require("./assets/images/React_d3_project_2.png"),
      projectName: "",
      projectDesc: "This project is a React and D3.js-based tool for visualizing vote distributions in the 2024 Lok Sabha elections with interactive charts and maps.",
      footerLink: [
        {
          name: "Visit Project",
          url: "https://github.com/ankitrajput0096/Lok_Sabha_Visualization_Project"
        }
      ]
    }
    ,
    {
      image: require("./assets/images/kubernetes_project.png"),
      projectName: "",
      projectDesc: "This repository contains a Dockerized full-stack app with Spring Boot, React-Redux, Material-UI, PostgreSQL, and a Kubernetes Minikube deployment setup.",
      footerLink: [
        {
          name: "Visit Project",
          url: "https://github.com/ankitrajput0096/Full_Stack_App_Using_Kubernetes"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Awards 🏆 "),
  subtitle:
    "Awards for some Cool Stuff that I have done !",
  linkedIn_profile_link: "https://www.linkedin.com/in/ankitrajput022/",

  achievementsCards: [
    {
      title: "PayPal Spot Award",
      subtitle:
      `
      I received this Award for effectively managing requirement changes and delivering the critical "Know Your Business" compliance feature on time.
      `,
      image: require("./assets/images/paypal_cert_1.png"),
      imageAlt: "PayPal Spot Award",
      footerLink: []
    },
    {
      title: "PayPal Bravo Award",
      subtitle:
      `
      I received this award for timely delivering the Adverse Action solution for PPWC through efficient collaboration with SMC and notifications teams.
      `,
      image: require("./assets/images/paypal_cert_3.png"),
      imageAlt: "PayPal Bravo Award",
      footerLink: []
    },
    {
      title: "Paytm Star Award",
      subtitle:
      `
      I received this award for managing financial reconciliation flows, resolving Due Past Days issues, and becoming a subject matter expert.
      `,
      image: require("./assets/images/paytm_cert_3.png"),
      imageAlt: "Paytm Star Award",
      footerLink: []
    },
    {
      title: "General Electric Impact Award",
      subtitle:
      `
      I received this award for developing the Gas Turbine Processing engine, ensuring its timely release, and creating a positive customer impact.
      `,
      image: require("./assets/images/ge_impact_cert.png"),
      imageAlt: "General Electric Impact Award",
      footerLink: []
    },
    {
      title: "General Electric Powerathon",
      subtitle:
      `
      I developed a machine learning solution during the hackathon to estimate the next servicing time based on turbine machinery part damage.
      `,
      image: require("./assets/images/ge_cert_4.png"),
      imageAlt: "General Electric Powerathon",
      footerLink: []
    },
    {
      title: "General Electric ERP.IO",
      subtitle:
      `
      I showcased an AI solution in the hackathon that automated database request resolution previously done manually.
      `,
      image: require("./assets/images/ge_cert_3.png"),
      imageAlt: "General Electric ERP.IO",
      footerLink: []
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@Ankitpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/Ankitpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Ankit-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "",
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ashutosh.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.AnkitRajput.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "1223 South Dorsey Lane,",
    locality: "Tempe, Maricopa County",
    country: "Arizona",
    region: "USA, 85281",
    postalCode: "95129",
    streetAddress: "Saratoga Avenue",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/t6kGtCb8P1Xrwhuj8",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
